import {Component, OnInit} from '@angular/core';
import {AppConfigService} from "../../../services/config/app-config.service";
import {TokenStorageService} from "../../../services/storage/token-storage.service";

@Component({
    selector: 'app-feed-api-component',
    templateUrl: './feed-api.component.html',
    styleUrls: ['./feed-api.component.css'],
    standalone: false
})
export class FeedApiComponent implements OnInit {
  feedProjectId: string | undefined;

  constructor(appConfig: AppConfigService) {
    this.feedProjectId = appConfig.getCommonConfig?.feedProjectId;
  }

  ngOnInit(): void {
  }
}
